(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[922],{

/***/ 592:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[slug]",
      function () {
        return __webpack_require__(7254);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var lib_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9157);
/* harmony import */ var lib_urls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5813);






const Helmet = (param)=>{
    let { title , description , keywords , image , children  } = param;
    const { t , locale  } = (0,lib_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const customTitle = title || t("FULL_NAME");
    const customDescription = description || t("HEAD_DESCRIPTION");
    const customKeywords = keywords || t("KEYWORDS");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const url = (0,lib_urls__WEBPACK_IMPORTED_MODULE_5__/* .getUrl */ .Gr)(router);
    const canonicalUrl = url.replace(".amp", "");
    const localeUrl = (0,lib_urls__WEBPACK_IMPORTED_MODULE_5__/* .getLocaleUrl */ .gc)(router, locale).replace(".amp", "");
    const host = (0,lib_urls__WEBPACK_IMPORTED_MODULE_5__/* .getHost */ .XF)();
    const imageURl = "".concat(host).concat(image);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: customTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://mc.yandex.ru",
                rel: "preconnect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://webring.xxiivv.com",
                rel: "preconnect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://www.googletagmanager.com",
                rel: "preconnect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://vitals.vercel-insights.com",
                rel: "preconnect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://www.google-analytics.com",
                rel: "preconnect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: canonicalUrl,
                rel: "canonical"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customTitle,
                name: "title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customDescription,
                name: "description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customKeywords,
                name: "keywords"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/sitemap.xml",
                rel: "sitemap",
                title: "Sitemap",
                type: "application/xml"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/rss/".concat(locale, "/posts/feed.xml"),
                rel: "alternate",
                title: t("BLOG_TITLE"),
                type: "application/rss+xml"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/rss/".concat(locale, "/posts/feed.json"),
                rel: "alternate",
                title: t("BLOG_TITLE"),
                type: "application/json"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/rss/".concat(locale, "/creativity/feed.xml"),
                rel: "alternate",
                title: t("CREATIVITY_TITLE"),
                type: "application/rss+xml"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/rss/".concat(locale, "/creativity/feed.json"),
                rel: "alternate",
                title: t("CREATIVITY_TITLE"),
                type: "application/json"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/favicon.ico",
                rel: "shortcut icon"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/logo192.png",
                rel: "apple-touch-icon"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "summary",
                name: "twitter:card"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customTitle,
                name: "twitter:title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: imageURl,
                property: "twitter:image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customTitle,
                property: "twitter:image:alt"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customDescription,
                property: "twitter:description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "@batyshkaLenin",
                property: "twitter:site"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "@batyshkaLenin",
                name: "twitter:creator"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: t("FULL_NAME"),
                property: "og:site_name"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: locale === "ru" ? "ru-RU" : "en-US",
                property: "og:locale"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customTitle,
                property: "og:title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: imageURl,
                property: "og:image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customDescription,
                property: "og:description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: localeUrl,
                property: "og:url"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: locale === "ru" ? "ru-RU" : "en-US",
                name: "DC.language"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "".concat(host, "/").concat(locale),
                name: "DC.publisher.url"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: localeUrl,
                name: "DC.identifier"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customTitle,
                name: "DC.title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customDescription,
                name: "DC.description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: customKeywords,
                name: "DC.subject"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "text",
                name: "DC.type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "text/html",
                name: "DC.format"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: t("FULL_NAME"),
                name: "apple-mobile-web-app-title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "default",
                name: "apple-mobile-web-app-status-bar-style"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: t("FULL_NAME"),
                name: "application-name"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "#070707",
                name: "theme-color"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/manifest-".concat(locale, ".json"),
                rel: "manifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://webmention.io/alexandr-sidorenko.me/webmention",
                rel: "webmention"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://webmention.io/alexandr-sidorenko.me/xmlrpc",
                rel: "pingback"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://alexandr-sidorenko.me/",
                rel: "openid.delegate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://openid.indieauth.com/openid",
                rel: "openid.server"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://indieauth.com/auth",
                rel: "authorization_endpoint"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://tokens.indieauth.com/token",
                rel: "token_endpoint"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://aperture.p3k.io/microsub/791",
                rel: "microsub"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://merveilles.town/@batyshkaLenin",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://www.linkedin.com/in/alexandr-sidorenko/",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://career.habr.com/batyshkalenin",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://www.tiktok.com/@batyshkalenin",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://hh.ru/applicant/resumes/view?resume=6700a5c7ff0594c2ba0039ed1f425a6c4a7771",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://www.instagram.com/alexander_sidorenko/",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://www.facebook.com/sidorenko.alexandr",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://steamcommunity.com/id/batyshkaLenin/",
                rel: "me"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/key.pub",
                rel: "pgpkey",
                type: "application/pgp-keys"
            }),
            children ? children : null
        ]
    });
};
Helmet.defaultProps = {
    image: "/images/me.png",
    children: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Helmet);


/***/ }),

/***/ 2944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ distanceToNow; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js + 6 modules
var formatDistanceToNowStrict = __webpack_require__(8103);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/ru/index.js + 8 modules
var ru = __webpack_require__(4363);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 5 modules
var en_US = __webpack_require__(5826);
// EXTERNAL MODULE: ./src/lib/types/index.ts + 3 modules
var types = __webpack_require__(9168);
;// CONCATENATED MODULE: ./src/lib/dates/distanceToNow.ts



function distanceToNow(dateTime) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* Locale.RU */.go.RU;
    return (0,formatDistanceToNowStrict/* default */.Z)(dateTime, {
        addSuffix: true,
        locale: locale === types/* Locale.RU */.go.RU ? ru/* default */.Z : en_US/* default */.Z
    });
}

;// CONCATENATED MODULE: ./src/lib/dates/index.ts



/***/ }),

/***/ 5813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XF": function() { return /* reexport */ getHost; },
  "gc": function() { return /* reexport */ getLocaleUrl; },
  "Gr": function() { return /* reexport */ getUrl; }
});

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/lib/urls/getHost.ts

const { publicRuntimeConfig , serverRuntimeConfig  } = config_default()();
const getHost = ()=>{
    const isServerSide = "object" === "undefined";
    return (isServerSide ? serverRuntimeConfig : publicRuntimeConfig).HOST;
};

;// CONCATENATED MODULE: ./src/lib/urls/getUrl.ts

const getUrl = (router)=>{
    const { asPath: path  } = router;
    const host = getHost();
    return host + path;
};

;// CONCATENATED MODULE: ./src/lib/urls/getLocaleUrl.ts

const getLocaleUrl = (router, locale)=>{
    const { asPath: path  } = router;
    const host = getHost();
    return locale === "ru" ? host + path : host + "/".concat(locale) + path;
};

;// CONCATENATED MODULE: ./src/lib/urls/index.ts





/***/ }),

/***/ 7254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "config": function() { return /* binding */ config; },
/* harmony export */   "default": function() { return /* binding */ PostPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_amp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9135);
/* harmony import */ var next_amp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_amp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Helmet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7240);
/* harmony import */ var lib_dates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2944);
/* harmony import */ var lib_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9157);
/* harmony import */ var lib_urls__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5813);








var __N_SSG = true;
const config = {
    amp: "hybrid"
};
function PostPage(param) {
    let { post  } = param;
    const { t  } = (0,lib_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const isAmp = (0,next_amp__WEBPACK_IMPORTED_MODULE_1__.useAmp)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const url = (0,lib_urls__WEBPACK_IMPORTED_MODULE_7__/* .getUrl */ .Gr)(router);
    const postURL = "/posts/".concat(post.slug);
    const breadcrumbs = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                item: {
                    "@id": "/posts",
                    url: "/posts",
                    name: t("MENU_BLOG")
                }
            },
            {
                "@type": "ListItem",
                position: 2,
                item: {
                    "@id": postURL,
                    url: postURL,
                    name: post.title
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Helmet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                description: post.description,
                image: post.preview,
                title: "".concat(post.title, " | ").concat(t("BLOG_TITLE")),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(url, ".amp"),
                        rel: "amphtml"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "article",
                        property: "og:type"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.author.firstName,
                        property: "og:article:author:first_name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.author.lastName,
                        property: "og:article:author:last_name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.author.username,
                        property: "og:article:author:username"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.author.gender,
                        property: "og:article:author:gender"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.published,
                        property: "og:article:published_time"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.modified,
                        property: "og:article:modified_time"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(breadcrumbs)
                        },
                        type: "application/ld+json"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                itemScope: true,
                className: "post-full post h-entry",
                itemProp: "blogPost",
                itemType: "https://schema.org/Article",
                children: [
                    isAmp ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("data", {
                                className: "u-photo",
                                value: "https://alexandr-sidorenko.me/avatar.jpg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("data", {
                                className: "u-url",
                                value: "https://alexandr-sidorenko.me".concat(postURL)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: post.preview || "/images/me.png",
                        itemProp: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                        className: "post-full-header",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "post-full-title p-name",
                                itemProp: "headline",
                                children: post.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                className: "p-author h-card",
                                content: t("FULL_NAME"),
                                itemProp: "author"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                content: post.created,
                                itemProp: "dateCreated"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                as: isAmp ? "".concat(postURL, "?amp=1") : postURL,
                                href: "/posts/[slug]",
                                itemProp: "url",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                    className: "text-center meta dt-published",
                                    dateTime: post.published,
                                    itemProp: "datePublished",
                                    children: (0,lib_dates__WEBPACK_IMPORTED_MODULE_5__/* .distanceToNow */ .e)(new Date(post.published))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "publicationContent e-content",
                        dangerouslySetInnerHTML: {
                            __html: post.content
                        },
                        itemProp: "articleBody"
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [925,774,888,179], function() { return __webpack_exec__(592); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);